import React from 'react'
import ReactDOM from 'react-dom/client'
import { getBrandConfig } from '@/config/config'
import { loadCatalog } from '@/i18n'

import { App } from '@/app'

import { setUTMs } from '@vgw/mar-utm-tracker'
import { Providers } from './providers'

const config = getBrandConfig()

await loadCatalog('en')
// set UTMs when application opened (a server navigation happened)
// this call is helpful when user navigating to the protected route
// and root layout has no chance to be called
setUTMs()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers amplitudeApiKey={config.amplitude.apiKey}>
      <App />
    </Providers>
  </React.StrictMode>,
)
